module.exports = __webpack_public_path__ + "img/7.7e698677.jpg";